export default __webpack_public_path__ + "images/emailBlue.v-16787c4a6f089e42f4f171481e56eedf.svg";